import React from 'react'

import s from './styles.module.scss'

interface IHouseSearchResultsEmptyStateProps {
  icon?: React.ReactNode
  firstElement?: React.ReactNode
  secondElement?: React.ReactNode
}

export const HouseSearchResultsEmptyState = ({
  icon,
  firstElement,
  secondElement,
}: IHouseSearchResultsEmptyStateProps) => {
  return (
    <div className={s.container}>
      {icon}
      {firstElement}
      {secondElement}
    </div>
  )
}
